import {styled} from "@mui/material/styles";
import {Box, Button, CircularProgress} from "@mui/material";
import React, {FunctionComponent} from "react";
import GetAppIcon from "@mui/icons-material/GetApp";
import {updateLastSearchFilterAction} from "../../../action/UpdateLastSearchFilterAction";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import {useTranslation} from "react-i18next";
import {useAppDispatch} from "../../../store/AppStore";
import {updateLastSearchResultAction} from "../../../action/UpdateLastSearchResultAction";

const StyledButtonsBox = styled(Box)(() => ({
    marginTop: '18px',
    display: 'flex',
    justifyContent: 'flex-end',
    "> button + button": {
        marginLeft: '10px',
    }
}));

export const ButtonsBox: FunctionComponent<SearchButtonProps> = props => {
    const {t} = useTranslation();
    const dispatch = useAppDispatch();

    return <StyledButtonsBox>
        {props.showExportButton && <Button
            disabled={props.isExporting}
            onClick={() => props.onExport()}
            variant="outlined"
            startIcon={<GetAppIcon/>}
            color="primary">
            {t("Export")}
            {props.isExporting && <CircularProgress sx={{marginLeft: '12px'}} size={18}/>}
        </Button>}
        <Button
            onClick={() => {
                dispatch(updateLastSearchFilterAction('', {}, undefined));
                dispatch(updateLastSearchResultAction(undefined, undefined));

                props.onReset();
            }}
            startIcon={<ClearIcon/>}
            variant="outlined"
            color="primary">
            {t("Clear")}
        </Button>
        <Button
            onClick={_ => {
                props.callSearchProducts();
            }}
            variant="contained"
            startIcon={<SearchIcon/>}
            color="primary">
            {t("Search")}
        </Button>
    </StyledButtonsBox>;
}

export interface SearchButtonProps {
    callSearchProducts: () => void;
    showExportButton?: boolean;
    onReset: () => void;
    onExport: () => void;
    isExporting?: boolean;
}